import React, { useEffect } from 'react';
import { BackgroundGrid } from './components/BackgroundGrid';
import { Hero } from './components/Hero';
import { HowItWorks } from './components/HowItWorks';
import { SignalsCarousel } from './components/SignalsCarousel';
import { Presentation } from './components/Presentation';
import { Pricing } from './components/Pricing';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotification } from './components/PurchaseNotification';
import { initMetaPixel } from './lib/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="min-h-screen relative selection:bg-brand-blue/30 selection:text-white" data-id="element-0">
      <BackgroundGrid data-id="element-1" />

      {/* Tight spacing between sections (~10px) for compact, focused UX */}
      <main className="flex flex-col gap-[10px]" data-id="element-2">
        <Hero data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <SignalsCarousel data-id="element-5" />
        <Presentation data-id="element-6" />
        <Pricing data-id="element-7" />
        <FinalCTA data-id="element-8" />
      </main>

      <Footer data-id="element-9" />
      <PurchaseNotification data-id="element-10" />
    </div>;
}